import React from 'react';
import RichFieldGroup from 'common/components/RichFieldGroup/RichFieldGroup';

const PictureTextRF = ({ groupId, groupStyle = {}, text, style = {} }) => {
  return (
    <figure
      style={style}
      className="sl-relative"
      role="group"
      aria-label={text}
    >
      <figcaption
        className="sl-absolute"
        style={{
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          pointerEvents: 'none',
          zIndex: 1,
        }}
      >
        <h2 className="sl-title-bloc sl-title">{text}</h2>
      </figcaption>
      <RichFieldGroup groupId={groupId} style={groupStyle}></RichFieldGroup>
    </figure>
  );
};

export default PictureTextRF;
